var _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25818 0.0146183C13.3318 0.0146183 17.1751 4.53528 16.4147 9.56746C15.8479 13.3139 13.8019 16.1895 11.1337 18.6917C10.3734 19.3968 9.54388 20.0189 8.7144 20.6272C8.50703 20.7793 8.05081 20.8207 7.87109 20.6963C4.4011 18.2355 1.55322 15.2632 0.378125 11.0329C-0.838445 6.67811 0.944937 2.50306 4.80202 0.774975C5.85269 0.304936 6.51627 0.152865 8.25818 0.0146183C8.27201 0.0837416 8.24436 -0.0406803 8.25818 0.0146183Z",
    fill: "#1D84D2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.02468,
    cy: 8.02566,
    r: 4.24831,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.7f7d2ea96d87cf5dffdb652ea338401b.svg";
export { ForwardRef as ReactComponent };